import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPrecustomerDetailsByPreCustomerId } from '../redux/features/oxygen/oxygenRetailSlice';

const OxyBookLoanModal = ({data}) => {
  const dispatch = useDispatch();
  const {oxygenBookLoan} = data;
    const oxygenRetail = useSelector((state) => state.oxygenRetail);
    const customerDetails = oxygenRetail?.preCustomerDetailsByPreCustomerId?.data;
     const storePrecustomer = useSelector((state) => state?.precustomer?.precustomerData);
    const isLoading = useSelector((state) => state.oxygenRetail?.bookloanLoading);

    useEffect(() => {
      dispatch(getPrecustomerDetailsByPreCustomerId (storePrecustomer.precustomer?.precustomerId))
    }, [dispatch, storePrecustomer.precustomer?.precustomerId]);

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="mb-0 card-title text-info">
          Customer Details
        </h3>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-md-12 mb-4">
            <div className="d-flex flex-column align-items-start my-2">
              <div className='mb-2'>
                <img
                  src={
                    customerDetails?.photoURL || customerDetails?.customerPhotoUrl ||
                    "assets/images/users/user_avatar.png"
                  }
                  alt="customer-pics"
                  style={{width: '100px', height: '100px'}}
                />
              </div>
              <div style={{padding: "20px 0 "}}>
                <p>Name: {`${customerDetails?.firstName || customerDetails?.fname } ${customerDetails?.lastName || customerDetails?.lname}`}</p>
                <p>Gender: {`${customerDetails?.gender} `}</p>
                <p>BVN: {`${customerDetails?.bvn || customerDetails?.bvnNumber} `}</p>
                {/* <p>NIN: {`${customerDetails?.idNumber}`}</p> */}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
            <button className="btn btn-primary btn-block" onClick={() => oxygenBookLoan()}>
              <b>{isLoading ? "Loading..." : "Book Loan"}</b>
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OxyBookLoanModal